//ProductHierarchy Thunks

import { createAsyncThunk } from '@reduxjs/toolkit';
import { ProductHierarchyApi } from '../../api/ProductHierarchyApi';
import { EActivity } from '../../data/Constants';

//To get product hierarchy paginated data
export const getProductHierarchy = createAsyncThunk(
  'productHierarchy/getProductHierarchy',
  async (action: { page: number; limit: number; searchCode?: string }, thunkAPI) => {
    return ProductHierarchyApi.getProductHierarchy(action, thunkAPI.dispatch);
  }
);

//Compares the product hierarchy and returns the differentiated data
export const compareProductHierarchy = createAsyncThunk(
  'productHierarchy/compareProductHierarchy',
  async (action: { page: number; limit: number; searchCode?: string }, thunkAPI) => {
    return ProductHierarchyApi.compareProductHierarchy(action, thunkAPI.dispatch);
  }
);

//Publishes the Product heirarchy
export const publishProductHierarchy = createAsyncThunk(
  'productHierarchy/publishProductHierarchy',
  async (action: { activity: EActivity }, thunkAPI) => {
    return ProductHierarchyApi.publishProductHierarchy(action, thunkAPI.dispatch);
  }
);
